import Api from '@/services/Api'

const URL = 'accounts/usuarios/';
const URL_PROFILE = 'accounts/usuarios/profile/';

export default {
    fetch(params) {
        return Api().get(URL, {
            params: params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if ('pk' in params) {
            params.id = params.pk;
            return Api().put(url + params.pk + '/', params)
        }
        return Api().post(url, params)
    },
    profile() {
        return Api().get(URL_PROFILE)
    }
}
